import type { CustomerOrigin } from './types';

export const hasFeatureEnabled = <T extends string>(
  toggleName: T,
  queryParamName: `btf${string}` = 'btf'
): boolean => {
  const searchParams = new URL(window.location.href).searchParams;
  return searchParams.getAll(queryParamName).includes(toggleName);
};

export function purifyUrl(url: string) {
  const { searchParams, host } = new URL(url);
  const urlSearchParams = new URLSearchParams(searchParams.toString());
  urlSearchParams.delete('btf');
  const newSearchParams = urlSearchParams.toString();
  return `${
    host.includes('localhost') ? 'http://' : 'https://'
  }${host}/travel/plan/?${newSearchParams}`;
}

export const removeProtocolAndDomainFromUrl = (url: string) =>
  url.replace(/^(?:https?:\/\/)?[^/]+/, '');

export const findYoutubeThumbnail = async (url: string) => {
  const parsedUrl = new URL(url);
  const urlParams = new URLSearchParams(parsedUrl.search);
  const videoId = urlParams.get('v') ?? parsedUrl.pathname.split('/')[1];
  const basePath = `https://img.youtube.com/vi/${videoId}/`;

  const thumbnail = `${basePath}0.jpg`;

  for (const thumbnailUrl of [
    `${basePath}maxresdefault.jpg`,
    `${basePath}hqdefault.jpg`,
  ]) {
    const response = await fetch(thumbnailUrl);
    if (response.status === 200) {
      return thumbnailUrl;
    }
  }

  return thumbnail;
};

export const addQueryParamsToUrl = (
  baseUrl: string,
  params?: {
    customerOrigin?: CustomerOrigin;
  }
): string => {
  const searchParams = new URLSearchParams();

  if (params?.customerOrigin) {
    searchParams.set('customer-origin', params.customerOrigin);
  }

  const queryString = searchParams.toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};
